import { render } from "./EntityForms.vue?vue&type=template&id=f09631fc&scoped=true"
import script from "./EntityForms.vue?vue&type=script&lang=js"
export * from "./EntityForms.vue?vue&type=script&lang=js"

import "./EntityForms.vue?vue&type=style&index=0&id=f09631fc&scoped=true&lang=css"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09631fc"]])

export default __exports__